import _ from "lodash";
import { FETCH_BODY_PARTS_ERROR, FETCH_BODY_PARTS_START, FETCH_BODY_PARTS_SUCCESS } from "../../actions/common/bodyPartsAction";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    bodyParts: []
};

const bodyPartsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_BODY_PARTS_START: {
            return { ...state, error: '', message: '', loading: true };
        }

        case FETCH_BODY_PARTS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, bodyParts: [...action.bodyParts] };
        }

        case FETCH_BODY_PARTS_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}

export default bodyPartsReducer;